import { Routes, Route } from 'react-router-dom';
import InazumaDle from './InazumaDle';
import HardMode from './HardMode';
import About from './About';
import Privacy from './Privacy';
import EndlessMode from './EndlessMode';
import Thanks from './Thanks';

function App() {
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<InazumaDle />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/hardmode" element={<HardMode />} />
        <Route path="/endlessmode" element={<EndlessMode />} />
        <Route path="/thanks" element={<Thanks />} />
      </Routes>
    </div>
  );
}

export default App;